import React from 'react';
import PropTypes from 'prop-types'
import UserAvatar from "../Atoms/Templates/UserAvatar";
import CircleCounter from "../Atoms/CircleCounter";

const UserAvatarList = ({ employees }) => {
  const employeesLimit = 3

  return (
    <div className="user-avatar-list s-cross-center nowrap">
      <div className="s-cross-center s-row-reverse s-main-end s-relative nowrap">
        {employees.slice(0, employeesLimit).map(() => (
          <UserAvatar
            className="small"
          />
        ))}
      </div>
      {employees.length > employeesLimit && (
        <CircleCounter counter={employees.length - employeesLimit}/>
      )}
    </div>
  );
};

UserAvatarList.propTypes = {
  employees: PropTypes.array.isRequired,
}

export default UserAvatarList;
